import './spinner.css';
import fala from '../../assets/fala.svg';

const Spinner: React.FC = () => {
    return (
        <div className="flex flex-col lg:flex-row lg:gap-6 justify-center items-center h-screen">
            {/* Fala Logo */}
            <div className="lg:mb-4">
                <img src={fala} alt="Falashop" className="w-32 h-32 md:w-36 md:h-36 lg:w-40 lg:h-40" />
            </div>

            {/* Spinner */}
            <div className="spinner w-16 h-16 lg:w-24 lg:h-24"></div>
        </div>
    );
};

export default Spinner;
